/* eslint-disable @angular-eslint/no-outputs-metadata-property */
/* eslint-disable @angular-eslint/component-selector */
/* eslint-disable @angular-eslint/no-inputs-metadata-property */
/* eslint-disable @typescript-eslint/no-unsafe-declaration-merging */
import { ChangeDetectionStrategy, Component, EventEmitter } from '@angular/core';

import { BaseProxyComponent } from '../lib/base.proxy';
import { ProxyWebComponent } from './../lib/utils';

import { DcrFilterChip } from '@diekeure/dcr-components';

export declare interface DcrFilterChipComponent extends DcrFilterChip {
  valueChange: EventEmitter<CustomEvent<string | string[]>>;
  selectedChange: EventEmitter<CustomEvent<boolean>>;
}

@ProxyWebComponent({ methods: ['select', 'selectItem', 'clearSelections'] })
@Component({
  selector: `
    dcr-filter-chip[formControl],
    dcr-filter-chip[formControlName],
    dcr-filter-chip[ngModel]
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: '<ng-content></ng-content>',
  inputs: [
    'label',
    'leadingIcon',
    'trailingIcon',
    'selected',
    'disabled',
    'hideCheck',
    'multiple',
    'clearable',
    'previewLimit',
    'menuPositioning',
    'typeaheadDelay',
    'quick',
    'value',
  ],
  outputs: ['valueChange', 'selectedChange'],
})
export class DcrFilterChipComponent extends BaseProxyComponent {}
